import { createContext, useContext } from 'react';

import { ProgressContextProps } from '../../model/progressModel';

export const DataGridProgressContext = createContext<ProgressContextProps>(null!);

const useDataGridProgressContext = () => {
  return useContext<ProgressContextProps>(DataGridProgressContext);
};

export default useDataGridProgressContext;
